// extracted by mini-css-extract-plugin
export default {"addBtn":"FieldTypes_addBtn__iB28I","tab":"FieldTypes_tab__NbF1l","overflowWrapper":"FieldTypes_overflowWrapper__L-loe","close":"FieldTypes_close__vnnID"};